// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { ApiPayload } from "../../../types";

interface MailchimpInstance {
	post(body: ApiPayload): Promise<unknown>;
}

// Module-level singleton instance
let instance: MailchimpInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createMailchimp(): MailchimpInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/mailchimp");

	return {
		post: async (body: ApiPayload): Promise<unknown> => {
			const url = new URL(baseUrl);
			try {
				return await baseNotary.postRequest(url, body);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getMailchimpInstance(): MailchimpInstance {
	if (!instance) {
		instance = createMailchimp();
	}
	return instance;
}
